{
  "add_company": "Add Company",
  "cards": {
    "company_settings": "Company settings",
    "entities": {
      "devices": "<strong>{{count}}</strong> devices",
      "sites": "<strong>{{count}}</strong> sites",
      "users": "<strong>{{count}}</strong> users"
    }
  },
  "header": "Companies",
  "my_companies": "My companies",
  "table": {
    "api_error": "There was an error loading companies",
    "columns": {
      "all_devices": "Devices",
      "all_sites": "Sites",
      "all_users": "Users",
      "company_type": "Company Type",
      "name": "Company Name",
      "user_role": "Role"
    },
    "filters": {
      "company_id": "Company Name",
      "company_type": "Company Type",
      "path": "Companies > Companies table",
      "user_role": "Role"
    },
    "no_data": "No companies available"
  },
  "toggle_company_relationship": "Show parent/child company relationship",
  "tooltips": {
    "children": {
      "Environment Operator": "Environment Operator",
      "Provider": "Provider company",
      "Reseller": "Reseller company",
      "text": "$t(tooltips.children.{{company_type}})<br />managing <strong>{{children}}</strong> companies"
    },
    "entities": {
      "devices": "devices",
      "sites": "sites",
      "text": "<strong>{{own}}</strong> own $t(tooltips.entities.{{property}}) and<br /><strong>{{managed}}</strong> managed $t(tooltips.entities.{{property}})",
      "users": "users"
    }
  }
}
